import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Context from '../../container';
import Footer from './footer';
import { isSSR } from '../../scripts/utils';
import { getBottomNavigation } from './services';

export default function FooterWrapper() {
  const { currentSite = {} } = useContext(Context);
  const [footerData, setFooterData] = useState({});
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1200);
  }, [history?.location?.pathname])

  // 确保服务端和客户端使用相同的 hostname 逻辑
  const getHostname = () => {
    if (isSSR) {
      // 服务端渲染时，从环境变量或请求头获取 hostname
      return process.env.TERMINUS_OFFICIAL_SITE_HOST || 'localhost';
    } else {
      // 客户端渲染时，从 window.location 获取
      return window.location.hostname || 'localhost';
    }
  };

  const hostname = getHostname();
  const [host = hostname, name] = hostname.match(/([^\\.]*?)\.[^\\.]*?$/) || [];
  const recordNumber = ({
    'terminus': 3,
    'quanzhi100': 4,
    'duandian': 5,
  })[name];

  useEffect(() => {
    (async() => {
      if(currentSite.id) {
        const {
          briefIntroductionList,
          aboutEndpointsList,
          discoverMoreList,
          quickLinksList,
        } = await getBottomNavigation({ site: { id: currentSite.id } });
        setFooterData({
          quickLinks: [{
            title: '关于端点',
            content: aboutEndpointsList.map((single) => ({
              title: single.menu,
              type: single.jumpMode,
              url: single.jumpToAddress,
            })),
          }, {
            title: '快速链接',
            content: quickLinksList.map((single) => ({
              title: single.menu,
              type: single.jumpMode,
              url: single.jumpToAddress,
            })),
          }, {
            title: '发现更多',
            content: discoverMoreList.map((single) => ({
              title: single.menu,
              type: single.jumpMode,
              url: single.codePicture,
            })),
          }],
          others: briefIntroductionList.map((single) => ({
            icon: single.logo,
            text: single.introductionContent
          })),
        });
      }
    })();
  }, [currentSite.id]);

  return loading ? null : (
    <Footer host={host} recordNumber={recordNumber} footerData={footerData} />
  );
}
